module.exports = __webpack_public_path__ + "img/save.1415e4a1.svg";